<script>
import {defineComponent} from 'vue'
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import moment from "moment";

export default defineComponent({
  name: "MinistryExecutionList",
  computed: {
    moment() {
      return moment
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
      modalVisible: false,
      excelForm: {
        file: [],
        date: null,
        title: null,
        type: null,
        currency: null,
        description: null,
      },
      expenseTypes: [
        {value: 'income', label: 'Daromad'},
        {value: 'outcome', label: 'Xarajat'}
      ],
      currencyTypes: [
        {value: 'mlrduzs', label: "Milliard so'm"},
        {value: 'mlnuzs', label: "Million so'm"},
      ],
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/my-school/secret-keys/excel`,
      uploadHeader: {Authorization: `${this.$store.state.accessToken}`},
      rules: {
        file: [{required: true, message: 'Faylni yuklash majburiy', trigger: "change"}],
        title: [{required: true, message: 'Nom majburiy', trigger: "blur"}],
        type: [{required: true, message: 'Majburiy', trigger: "change"}],
        currency: [{required: true, message: 'Majburiy', trigger: "change"}],
        description: [{required: true, message: 'Izoh majburiy', trigger: "blur"}],
      }
    }
  },
  methods: {
    onClick() {
      this.excelForm = {
        file: [],
        date: null,
        title: null,
        type: null,
        currency: null,
        description: null,
      }
      this.modalVisible = true
    },
    closeEditingModal() {
      this.modalVisible = false;
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.limit + 1
    },
    handleCurrentChange() {
      this.getMinistries();
    },
    handleSizeChange() {
      this.page = 1;
      this.getMinistries();
    },
    onClickDelete(id) {
      ElMessageBox.confirm(
          'Ma\'lumoitni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v1/ministries-execution/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              this.getMinistries();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },

    getMinistries() {
      this.loading = true;
      this.$http.get(`api/v1/ministries-execution`, {
        params: {
          limit: this.limit,
          offset: this.limit * (this.page - 1)
        }
      }).then(({data}) => {
        this.tableData = data.data;
        this.totalCount = data.count;
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },

    onSaveExcelInfo() {
      this.$refs.form.validate((valid) => {
        if (valid && this.excelForm.file?.length) {
          this.loading = true;

          const formData = new FormData();

          formData.append('title', this.excelForm.title);
          formData.append('type', this.excelForm.type);
          formData.append('currency', this.excelForm.currency);
          formData.append('description', this.excelForm.description);
          formData.append('date', this.excelForm.date);
          formData.append('file', this.excelForm.file?.[0]?.raw);

          this.$http.post('/api/v1/state-budget/excel-economy/upload-excel', formData, {
            headers: {
              "Content-Type": 'multipart/form-data'
            }
          })
              .then(() => {
                ElNotification({
                  message: "Ma'lumotlar saqlandi!",
                  type: "success",
                });
                this.modalVisible = false
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Ogohlantirish",
                  message:
                      response.data.message ||
                      "Ma'lumot saqlashda xatolik sodir bo'ldi!",
                  type: "warning",
                });
              })
              .finally(() => {
                this.loading = false
              })
        }
      })
    }
  },
  mounted() {
    this.getMinistries()
  }
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div>
        <el-button @click="onClick" style="width: 100%" type="success">
          Excel orqali kiritish
        </el-button>
      </div>
      <el-button type="primary" @click="$router.push({name: 'MinistryExecutionFormAdd'})">Qo'shish</el-button>
    </div>
    <el-table :data="tableData" class="table" border height="calc(100vh - 245px)">
      <el-table-column type="index" label="T/R" width="80" :index="indexMethod" align="center"/>
      <el-table-column prop="ministry" label="Vazirlik" min-width="220"/>
      <el-table-column prop="plan" label="Reja" min-width="120"/>
      <el-table-column prop="quarter" label="Chorak" min-width="80"/>
      <el-table-column prop="executed" label="Bajarilgan" min-width="200"/>
      <el-table-column prop="difference" label="Farqi" min-width="80"/>
      <el-table-column prop="percent" label="Foiz" min-width="70"/>
      <el-table-column prop="created_at" label="Yaratilgan sana" min-width="140">
        <template v-slot="scope">
          {{ moment(scope.row.created_at).format("DD.MM.YYYY") }}
        </template>
      </el-table-column>
      <el-table-column label="" width="200" align="center">
        <template #default="scope">
          <el-button type="primary" size="small"
                     @click="$router.push({name: 'MinistryExecutionFormEdit', params:{id: scope.row.id}})">Tahrirlash
          </el-button>
          <el-button type="danger" size="small"
                     @click="onClickDelete(scope.row.id)">O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>

  <el-dialog
      v-model="modalVisible"
      @close="closeEditingModal"
      title="Vazirliklarning xarajatlari va daromadlari hisobotini kiritish"
      align-center
  >
    <el-form
        ref="form"
        :model="excelForm"
        :rules="rules"
        label-position="top"
        size="large"
    >
      <el-form-item label="Hujjat nomini kiriting" prop="title">
        <el-input type="text" v-model="excelForm.title" placeholder="Kiriting"/>
      </el-form-item>
      <el-form-item label="Turini tanlang" prop="type">
        <el-select v-model="excelForm.type" placeholder="Tanlang" style="width: 100%">
          <el-option v-for="type in expenseTypes" :key="type.value" :value="type.value" :label="type.label"/>
        </el-select>
      </el-form-item>
      <el-form-item label="Mablag' turi" prop="currency">
        <el-select v-model="excelForm.currency" placeholder="Tanlang" style="width: 100%">
          <el-option v-for="type in currencyTypes" :key="type.value" :value="type.value" :label="type.label"/>
        </el-select>
      </el-form-item>
      <el-form-item label="Sana" prop="date">
        <el-date-picker
            placeholder="Sana tanlang"
            style="width: 100%"
            v-model="excelForm.date"
            format="DD.MM.YYYY"
            value-format="YYYY-MM-DD"
        />
      </el-form-item>
      <el-form-item label="Excel faylini yuklang" prop="file">
        <el-upload
            ref="uploadRef"
            class="upload-demo"
            :auto-upload="false"
            :multiple="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            v-model:file-list="excelForm.file"
            :limit="1"
        >
          <template #trigger>
            <el-button type="warning">Excel faylni tanlang</el-button>
          </template>
        </el-upload>
      </el-form-item>
      <el-form-item label="Izoh">
        <el-input type="textarea" v-model="excelForm.description" placeholder="Kiriting..."/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSaveExcelInfo">
          Saqlash
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 10px;
  align-items: center;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
